import styled from 'styled-components';
import Palette from '@/styles/Themes/Palette';

export const Online = styled.span`
    color: ${Palette.green.normal};
`;
